<script setup lang="ts">
import { resize } from "@/utils/index";
import { onMounted } from "vue";
import { useDevice } from "@/hooks/useDevice";
import { useRouter, useRoute } from "vue-router";

// 路由跳转
const { isMobile } = useDevice();
const { push } = useRouter();
function goto() {
  let hash = window.location.hash;
  if (isMobile) {
    let path = hash.includes("mobile")
      ? hash.replace("#", "")
      : hash.replace("/", "/mobile/").replace("#", "");
    if (path === "/") path = "/mobile";
    push(path);
  } else {
    let path = hash.replace("/mobile/", "/").replace("/web/", "/").replace("#", "");
    if (path === "/") path = "/";
    push(path);
  }
}
goto();

window.addEventListener("resize", resize);
onMounted(() => {
  resize();
});
</script>

<template>
  <router-view />
</template>

<style>
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue",
    Arial, sans-serif;
  line-height: 1.6;
  color: #333;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
}

/* 容器响应式 */
.container {
  width: 100%;
  margin: 0 auto;
  padding: 0 1rem;
}

@media (min-width: 640px) {
  .container {
    padding: 0 1.5rem;
  }
}

@media (min-width: 1024px) {
  .container {
    padding: 0 2rem;
    max-width: 1200px;
  }
}

@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}

@media (min-width: 1536px) {
  .container {
    max-width: 1400px;
  }
}

/* 链接样式 */
a {
  text-decoration: none;
  color: inherit;
}

a:hover {
  text-decoration: none;
}

/* 按钮基础样式 */
button {
  cursor: pointer;
  border: none;
  outline: none;
  background: none;
  font-family: inherit;
}

/* 响应式图片 */
img {
  max-width: 100%;
  height: auto;
}

/* 移动端优化 */
@media (max-width: 768px) {
  .text-4xl {
    font-size: 2rem;
  }

  .text-5xl {
    font-size: 2.5rem;
  }

  .text-6xl {
    font-size: 3rem;
  }
}
</style>
